import { NotificationEntitiesType } from '@notifications/models/notification-entities-type';
import { NotificationStatus } from '@notifications/models/notification-status';
import { NotificationType } from '@notifications/models/notification-type';

export const INSPECTION_NOTIFICATIONS: NotificationEntitiesType = {
  [NotificationType.InspectionReport]: {
    messages: {
      [NotificationStatus.InProgress]: {
        title: 'Generating report',
        message:
          '{{inspectionName}} inspection report is being generated<br><span class="image_quality text-small">Image quality: {{imageQuality}}</span>'
      },
      [NotificationStatus.Completed]: {
        title: 'Report generated',
        message:
          '{{inspectionName}} inspection report is available<br><span class="image_quality text-small">Image quality: {{imageQuality}}</span>'
      },
      [NotificationStatus.Failed]: {
        title: 'Generating report failed',
        message:
          'Generating {{inspectionName}} inspection report failed<br><span class="image_quality text-small">Image quality: {{imageQuality}}</span>'
      },
      [NotificationStatus.Unavailable]: {
        title: 'Connectivity issues',
        message:
          '{{inspectionName}} inspection report generation status unknown, retrying<br><span class="image_quality text-small">Image quality: {{imageQuality}}</span>'
      }
    },
    label: 'Download Report'
  },
  [NotificationType.InspectionExcelExport]: {
    messages: {
      [NotificationStatus.InProgress]: {
        title: 'Generating Export',
        message: 'Inspection item data is being exported to Excel'
      },
      [NotificationStatus.Completed]: {
        title: 'Export complete',
        message: 'Inspection item data is available for download'
      },
      [NotificationStatus.Failed]: {
        title: 'Export failed',
        message: 'Exporting inspection item data to Excel failed'
      },
      [NotificationStatus.Unavailable]: {
        title: 'Connectivity issues',
        message: 'Inspection item data status unknown, retrying'
      }
    },
    label: 'Download Excel'
  },
  [NotificationType.InspectionAttachmentsDownload]: {
    messages: {
      [NotificationStatus.InProgress]: {
        title: 'Generating ZIP',
        message:
          '<b>[{{inspectionName}}]</b> inspection attachments ZIP is being generated'
      },
      [NotificationStatus.Completed]: {
        title: 'ZIP generated',
        message:
          '<b>[{{inspectionName}}]</b> inspection attachments ZIP is available'
      },
      [NotificationStatus.Failed]: {
        title: 'Generating ZIP failed',
        message:
          'Generating <b>[{{inspectionName}}]</b> inspection attachments ZIP failed'
      },
      [NotificationStatus.Unavailable]: {
        title: 'Connectivity issues',
        message:
          '<b>[{{inspectionName}}]</b> inspection attachments ZIP generation status unknown, retrying'
      }
    },
    label: 'Download ZIP'
  },
  [NotificationType.InspectionItemAttachmentsDownload]: {
    messages: {
      [NotificationStatus.InProgress]: {
        title: 'Generating ZIP',
        message:
          '<b>[#{{inspectionItemName}}]</b> item attachments ZIP is being generated'
      },
      [NotificationStatus.Completed]: {
        title: 'ZIP generated',
        message:
          '<b>[#{{inspectionItemName}}]</b> item attachments ZIP is available'
      },
      [NotificationStatus.Failed]: {
        title: 'Generating ZIP failed',
        message:
          'Generating <b>[#{{inspectionItemName}}]</b> item attachments ZIP failed'
      },
      [NotificationStatus.Unavailable]: {
        title: 'Connectivity issues',
        message:
          '<b>[#{{inspectionItemName}}]</b> item attachments ZIP generation status unknown, retrying'
      }
    },
    label: 'Download ZIP'
  }
};
